'use client'

import React, { useEffect, useState } from 'react';
import Link from 'next/link';
import classnames from 'classnames';
import s from './LegalPopup.module.scss';

export default function LegalPopup() {
  const [closed, setClosed] = useState(true);

  useEffect(() => {
    const storedValue = localStorage.getItem('closed_legal_popup');
    setClosed(storedValue === 'true');
  }, []);

  const closePopup = () => {
    setClosed(true);
    localStorage.setItem('closed_legal_popup', 'true');
  };

  return (
    <div className={classnames(s.root, closed && s.hidden)}>
      <p>
        By using this site, you agree to the
        <Link href="/privacy-policy">Privacy Policy.</Link>
      </p>
      <button
        type="button"
        aria-label="Close privacy policy notification"
        className={s.closeButton}
        onClick={closePopup}
      />
    </div>
  );
};
